import axios from 'axios';
import config from '../../lib/requestConf/config';
import {data} from "autoprefixer";
import {Toast} from "vant"


// 创建一个 axios 实例
const service = axios.create({
    baseURL: config.baseUrl,
    timeout: 60000, // 请求超时时间
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
    },
},
);

// 请求拦截器
service.interceptors.request.use(
    (config) => {
        config.headers['token'] = localStorage.getItem('token') || '';
        return config;
    },
    (error) => {
        // 发送失败
        Promise.reject(error);
    },
);
// 响应拦截器
service.interceptors.response.use(
    (response) => {
        // dataAxios 是 axios 返回数据中的 data
        const dataAxios = response.data;
        // 这个状态码是和后端约定的
        const { code } = dataAxios;
        // 根据 code 进行判断
        if (code === undefined) {
            // 如果没有 code 代表这不是项目后端开发的接口
            return dataAxios;
        }
        // 有 code 代表这是一个后端接口 可以进行进一步的判断
        console.log("response=============", dataAxios)
        return Promise.resolve(dataAxios);

        switch (code) {
            case 200:
                return Promise.resolve(dataAxios);
            default:
                Toast("请求错误");
                // 不是正确的 code
                //errorCreate(`[ code: ${code} ]${dataAxios.msg}: ${response.config.url}`);
                return null;
        }
    },
    (error) => {
        error.message = '系统异常，请稍后再试';
        if (error && error.response) {
            switch (error.response.status) {
                case 400: error.message = '请求错误'; break;
                case 401:
                    error.message = '登录失效，请重新登录';
                    break;
                case 403: error.message = '拒绝访问'; break;
                case 404: error.message = `请求地址出错: ${error.response.config.url}`; break;
                case 408: error.message = '请求超时'; break;
                case 500: error.message = '服务器内部错误'; break;
                case 501: error.message = '服务未实现'; break;
                case 502: error.message = '网关错误'; break;
                case 503: error.message = '服务不可用'; break;
                case 504: error.message = '网关超时'; break;
                case 505: error.message = 'HTTP版本不受支持'; break;
                default: break;
            }
        }
        return Promise.reject(error);
    },
);


export default service;



// WEBPACK FOOTER //
// ./src/lib/requestConf/axiosUtils.js